import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../../i18n';


/**
 * @summary WizardSteps
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('wizard-steps')
class WizardSteps extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of WizardSteps.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'wizard-steps';

  @property({type: Number})
  step = 1;

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default WizardSteps;
